module.exports = __webpack_public_path__ + "img/backimglogin.202d731a.jpg";